export default __webpack_public_path__ + "static/media/Image-2.cbf6fdfa.jpg";